export default {
  rooms: {
    data: [],
    last_update: null,
  },
  loading_rooms: false,
  rooms_on_view: [],
}
